var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('incomes-chart',{attrs:{"incomes":_vm.flatIncomes}}),_c('div',{class:_vm.b('title')},[_vm._v("Ingresos reportados los últimos 6 meses")]),_c('div',{class:_vm.b('table-container')},[_c('incomes-last-months-table',{attrs:{"incomes":_vm.lastIncomes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }